<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">핏페이 매출</span>
            <span class="txt">핏페이 결제에 관한 결제현황과 매출을 확인합니다.</span>
        </div>

        <div class="com-tab">
            <span v-for="(item, index) in submenus" :key="index">
                <router-link :class="{ on: $route.name == item.name }" :to="{ ...item, params: { centerId } }">
                    {{ item.label }}
                </router-link>
            </span>
        </div>

        <div class="fit-filter-search mt-16">
            <div class="mb-4">
                <div class="com-search-input">
                    <input
                        v-model="searchStr"
                        placeholder="검색어를 입력해주세요"
                        class="mr-2"
                        type="text"
                        v-on:keyup.enter="onEventSearch"
                    />
                    <button class="com-btn drop" :class="openFilter ? 'up' : 'down'" @click="openFilter = !openFilter">
                        필터 검색
                    </button>
                    <button class="com-search-reset" @click="resetSearchContent"></button>
                </div>
            </div>
            <table class="com-table" :class="openFilter ? '' : 'd-none'">
                <colgroup>
                    <col style="width: 120px" />
                    <col style="width: auto" />
                    <col style="width: 120px" />
                    <col style="width: auto" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>기간</th>
                        <td colspan="3">
                            <div class="d-flex align-items-center">
                                <select-form
                                    :select-data="['결제일', '정산액입금일']"
                                    :select-value="['trDt', 'settlmntDt']"
                                    :selected-value="searchDateType"
                                    @update:set="(val) => (searchDateType = val)"
                                ></select-form>
                                <div class="com-calendar-wrap ml-2">
                                    <single-calendar
                                        :start-date="startDate"
                                        @update="startDateUpdate"
                                    ></single-calendar>
                                    <div class="com-dash"><span class="dash">~</span></div>
                                    <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                                </div>
                                <select-form
                                    :select-data="['선택', ...periodTypeList]"
                                    :select-value="['', ...periodTypeValueList]"
                                    :selected-value="searchPeriod"
                                    @update:set="(val) => (searchPeriod = val)"
                                ></select-form>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>정산 상태</th>
                        <td colspan="3">
                            <div class="d-flex align-items-center">
                                <div v-for="(item, index) in settleStates" :key="index" class="com-box-radio md">
                                    <input
                                        :id="'state-type-' + index"
                                        v-model="searchState"
                                        :value="item.value"
                                        name="state-type"
                                        required
                                        type="radio"
                                    />
                                    <label :for="'state-type-' + index">{{ item.text }}</label>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="sub-title">정산 현황</div>
        <!-- 매출현황 상품일시 -->
        <div class="sales-info-table w-auto mt-6">
            <div class="top-content">
                <div class="item-box flex-fill">
                    <span class="tit">
                        결제 완료
                        <span class="sub">PG사 결제 금액</span>
                    </span>
                    <span class="count">
                        <span class="num blue">{{ (prices.bill_price || 0) | numberFormatFilter }}원</span>
                        <span class="txt">({{ (prices.bill_count || 0) | numberFormatFilter }}건)</span>
                    </span>
                </div>
                <div class="item-box minus"></div>
                <div class="item-box flex-fill">
                    <span class="tit">공제 수수료</span>
                    <span class="count">
                        <span class="num red">
                            {{ (Number(prices.fee_price || 0) + Number(prices.vat_price || 0)) | numberFormatFilter }}원
                        </span>
                        <span class="txt">({{ (prices.fee_count || 0) | numberFormatFilter }}건)</span>
                    </span>
                </div>
                <div class="item-box equal"></div>
                <div class="item-box flex-fill">
                    <span class="tit">
                        정산 금액
                        <span class="sub">결제금액 - 공제 수수료</span>
                    </span>
                    <span class="count">
                        <span class="num green">{{ (prices.settl_price || 0) | numberFormatFilter }}원</span>
                    </span>
                </div>
            </div>
        </div>
        <!-- //매출현황 상품일시 -->

        <div class="sub-title mt-10">정산 내역</div>
        <div class="com-table-content">
            <table class="com-table">
                <colgroup>
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 'auto'" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <button :class="sortClassState('결제일')" @click="handleSortColumn('결제일')">
                                결제일
                            </button>
                        </th>
                        <th>
                            <button :class="sortClassState('정산액 입금일')" @click="handleSortColumn('정산액 입금일')">
                                정산액 입금일
                            </button>
                            <div class="com-tooltip">
                                <button class="icon"></button>
                                <div class="detail">
                                    <p class="txt">정산액 입금일은 영업일 기준 5일로 계산됩니다.</p>
                                </div>
                            </div>
                        </th>
                        <th>정산 상태</th>
                        <th>
                            <button :class="sortClassState('결제금액')" @click="handleSortColumn('결제금액')">
                                결제금액
                            </button>
                        </th>
                        <th>
                            공제수수료
                            <div class="com-tooltip">
                                <button class="icon"></button>
                                <div class="detail">
                                    <p class="txt">PG(온라인 결제) 및 핏페이 수수료가 모두 포함된 금액입니다.</p>
                                </div>
                            </div>
                        </th>
                        <th>
                            <button :class="sortClassState('정산금액')" @click="handleSortColumn('정산금액')">
                                정산금액
                            </button>
                        </th>
                        <th>
                            <button :class="sortClassState('주문번호')" @click="handleSortColumn('주문번호')">
                                주문번호
                            </button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="s in settlementList" :key="s.key">
                        <td>{{ s.ns_tr_dt | dateFormatFilter }}</td>
                        <td>{{ s.ns_settlmnt_dt | dateFormatFilter }}</td>
                        <td>
                            <span v-if="s.ns_status === 'D'" class="pay-state-D">정산완료</span>
                            <span v-else class="">정산대기</span>
                        </td>
                        <td>
                            <div class="text-right">{{ s.ns_tr_amt | numberFormatFilter }}원</div>
                        </td>
                        <td>
                            <div class="text-right">
                                {{ (Number(s.ns_fee) + Number(s.ns_vat)) | numberFormatFilter }}원
                            </div>
                        </td>
                        <td>
                            <div class="text-right">{{ s.ns_deposit_amt | numberFormatFilter }}원</div>
                        </td>
                        <td>
                            <button class="link" @click="selectedMoid = s.ns_moid">{{ s.ns_moid }}</button>
                        </td>
                    </tr>
                    <tr v-if="settlementList.length == 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <!-- 추후에 구현함 -->
                <button class="com-btn excel" @click="excelDownload">엑셀 다운로드</button>
                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
            <b-pagination
                v-model="pagingInfo.page"
                :per-page="pagingInfo.limit"
                :total-rows="pagingInfo.totalItems"
                align="center"
                aria-controls="my-table"
                first-class="first"
                last-class="last"
                next-class="next"
                prev-class="prev"
                @change="handlerPagenation($event)"
            ></b-pagination>
        </div>

        <payment-history-dlg
            v-if="!!selectedMoid"
            :show="!!selectedMoid"
            :moid="selectedMoid || ''"
            :close="() => (selectedMoid = '')"
        ></payment-history-dlg>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';
import EventBus from '../../../assets/js/eventBus';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import XLSX from 'xlsx';
import { numberFormat, dateFormatFilter } from '@/assets/js/excelCommon.js';
import { pagingInfo } from '@/assets/js/common';
import PaymentHistoryDlg from '@/components/PaymentHistoryDlg.vue';

export default {
    name: 'SalesFitSettlement',
    mixins: [MixinAllowedMenu],
    components: { PaymentHistoryDlg },
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        centerChains() {
            const { getters } = this.$store;
            return getters['auth/centerChains'];
        },
        totalPrice() {
            return 0;
        },
    },
    watch: {
        searchPeriod(newValue) {
            // 검색 기간 설정 변수
            this.searchPeriod = newValue;

            if (newValue === 'today') {
                // 오늘
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                // 어제
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'thisMonth') {
                // 이번 달
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                // 지난 달
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === '3M') {
                // 3개월
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '6M') {
                // 6개월
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '12M') {
                // 12개월
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '') {
                this.initStartDate();
                this.initEndDate();
            }
            this.fetchList(1);
        },
        startDate(newValue) {
            // 검색 시작일
            this.startDate = newValue;
            this.fetchList(1);
        },
        endDate(newValue) {
            // 검색 종료일
            this.endDate = newValue;
            this.fetchList(1);
        },
        searchState(newValue) {
            // 결제항목
            this.searchState = newValue;
            this.fetchList(1);
        },
        searchDateType(newValue) {
            this.searchDateType = newValue;
            this.fetchList(1);
        },
    },
    data() {
        return {
            openFilter: true,
            openBankbookDlg: false,
            defaultImageUrl: '', // TODO: 센터 통장사본 조회
            submenus: [
                { name: 'SalesFitPayment', label: '결제 내역' },
                { name: 'SalesFitSettlement', label: '정산 내역' },
            ],
            settleStates: [
                { text: '전체', value: '' },
                { text: '정산완료', value: '0' },
                { text: '정산대기', value: '1' },
                // {text: '입금대기', value: '1'},
            ],
            sortColumns: {
                결제일: 'tr_dt',
                '정산액 입금일': 'settlmnt_dt',
                결제금액: 'tr_amt',
                정산금액: 'deposit_amt',
                주문번호: 'moid',
            },
            sortColumn: 'tr_dt',
            sortType: 'DESC',

            centerId: '',
            settlementList: [],
            startDate: moment().startOf('month').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),

            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],
            pagingInfo: { ...pagingInfo },
            periodTypeList: [...this.$periodTypeList],
            periodTypeValueList: [...this.$periodTypeValueList],
            searchStr: '', // 이름, 연락처 검색 파라미터
            searchPeriod: '', // 검색 기간 설정

            selectedMoid: '', // 선택된 주문번호

            searchState: '',
            searchDateType: 'trDt',
            prices: {},
        };
    },
    mounted() {
        this.centerId = this.cId; // 센터id
        this.pagingInfo.page = 1;
        this.pagingInfo.limit = 10;
        this.fetchList(1);
    },
    methods: {
        // 리스트 조회 api
        async fetchList(pnum) {
            try {
                const { data } = await api.get(`/admin/api/center/fitpay/settlements/${this.centerId}`, {
                    params: {
                        searchStr: this.searchStr,
                        dateType: this.searchDateType,
                        startDate: moment(this.startDate).format('YYYYMMDD'), // 검색시작일
                        endDate: moment(this.endDate).format('YYYYMMDD'), // 검색종료일
                        status: this.searchState || '',
                        sortColumn: this.sortColumn,
                        sortType: this.sortType,
                        ...this.pagingInfo,
                        page: pnum || this.pagingInfo.page,
                    },
                });
                this.setPageParams(data);
                this.settlementList = data.items;
                this.prices = data.prices || {};
            } catch (error) {
                console.log(error);
                console.log('정산내역 리스트 오류입니다.');
            }
        },
        // 페이징 기본값
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },

        sortClassState(sortName) {
            if (!sortName) return '';
            const sortCol = this.sortColumns[sortName] || '';
            if (sortCol === this.sortColumn) return this.sortType === 'DESC' ? 'desc' : 'asc';
            return 'none';
        },
        async handleSortColumn(sortName) {
            if (!sortName) return;
            const sortCol = this.sortColumns[sortName] || '';

            if (sortCol === this.sortColumn) this.sortType = this.sortType === 'DESC' ? 'ASC' : 'DESC';
            else this.sortType = 'DESC';

            this.sortColumn = sortCol;
            this.fetchList();
        },
        // 가격정보 변환
        convertBill(bill) {
            if (bill == null || bill == undefined) {
                return '';
            }
            const a = bill.split('|');
            const data = [];
            for (const e of a) {
                const b = e.split('_');
                data.push({
                    type: b[0],
                    amount: parseInt(b[1]),
                });
            }

            let sum = {};
            let type = '';
            for (const c of data) {
                if (sum.type == undefined) {
                    sum = c;
                } else {
                    sum.amount += c.amount;
                }
            }

            if (sum.type == 'C') {
                type = '카드';
            } else if (sum.type == 'L') {
                type = '현금';
            } else if (sum.type == 'B') {
                type = '계좌이체';
            } else if (sum.type == 'M') {
                type = '마일리지';
            } else if (sum.type == 'E') {
                type = '기타';
            }

            const result = `${type} ${sum.amount}원`;
            return result;
        },
        // 페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.fetchList();
        },

        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.limit = val;
            this.fetchList();
        },
        // 검색 조건 초기화
        resetSearchContent() {
            this.searchStr = '';
            EventBus.$emit('event:initList', 'init');
        },

        // 검색 시작일 초기화
        initStartDate() {
            this.startDate = moment().subtract(1, 'years').format('YYYY-MM-DD');
        },

        // 검색 종료일 초기화
        initEndDate() {
            this.endDate = moment().format('YYYY-MM-DD');
        },

        // 회원 목록 키워드 검색 이벤트
        onEventSearch(e) {
            if (this.searchStr.length > 0 && this.searchStr.length < 2) {
                return;
            }
            this.fetchList();
        },
        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
            if (this.dateChangeCount > 2) {
                this.fetchList(1);
            }
            this.dateChangeCount += 1;
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
            if (this.dateChangeCount > 2) {
                this.fetchList(1);
            }
            this.dateChangeCount += 1;
        },
        async excelDownload() {
            // 엑셀 다운로드 기능구현
            const { data } = await this.fetchListExcel(1, 100000); // 엑셀용 요청값

            let sum_bill_price = 0,
                sum_fee = 0,
                sum_settl_price = 0;
            const excelDownloadArray = [];
            data.items.forEach((s) => {
                const temp = {};
                temp['결제일'] = dateFormatFilter(s.ns_tr_dt);
                temp['정산액 입금일'] = dateFormatFilter(s.ns_settlmnt_dt);
                if (s.ns_status === 'D') {
                    temp['정산상태'] = '정산완료';
                } else {
                    temp['정산상태'] = '정산대기';
                }
                temp['결제금액'] = numberFormat(s.ns_tr_amt || 0);
                temp['공제수수료'] = numberFormat(Number(s.ns_fee || 0) + Number(s.ns_vat || 0));
                temp['정산금액'] = numberFormat(s.ns_deposit_amt || 0);
                temp['주문번호'] = s.ns_moid;

                sum_bill_price += s.ns_tr_amt || 0;
                sum_fee += Number(s.ns_fee || 0) + Number(s.ns_vat || 0);
                sum_settl_price += s.ns_deposit_amt || 0;

                excelDownloadArray.push(temp);
            });

            const temp = {};
            temp['결제일'] = '합계';
            temp['정산액 입금일'] = '';
            temp['정산상태'] = '';
            temp['결제금액'] = numberFormat(sum_bill_price);
            temp['공제수수료'] = numberFormat(sum_fee);
            temp['정산금액'] = numberFormat(sum_settl_price);
            temp['주문번호'] = '';

            excelDownloadArray.push(temp);

            /* [Key:value,...] */
            const dataWS = XLSX.utils.json_to_sheet(excelDownloadArray); // 배열을 넣어야함.
            // cell width 설정
            const wscols = [{ wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 15 }];
            dataWS['!cols'] = wscols;

            // cell height 설정
            const wsrows = [{ hpx: 30 }];
            dataWS['!rows'] = wsrows;

            const wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, dataWS, '핏페이 매출(정산내역)');
            XLSX.writeFile(wb, '핏페이매출_정산내역.xlsx');
        },
        fetchListExcel(page, limit) {
            return api.get(`/admin/api/center/fitpay/settlements/${this.centerId}`, {
                params: {
                    searchStr: this.searchStr,
                    dateType: this.searchDateType,
                    startDate: moment(this.startDate).format('YYYYMMDD'), // 검색시작일
                    endDate: moment(this.endDate).format('YYYYMMDD'), // 검색종료일
                    status: this.searchState || '',
                    sortColumn: this.sortColumn,
                    sortType: this.sortType,
                    ...this.pagingInfo,
                    page,
                    limit,
                },
            });
        },
    },
};
</script>
<style lang="scss"></style>
